import type { FilterFunc } from "rc-select/lib/Select";
import type { Location } from "../../generated-axios-client";
import type { DefaultOptionType } from "antd/es/cascader";
import type { IntlShape } from "@formatjs/intl";
import type { FormInstance, Rule } from "antd/es/form";
import { Form, Select, type SelectProps } from "antd";
import { useEffect, useMemo } from "react";
import { useWatch } from "antd/es/form/Form";

const locationSelectOptions = (locationItems: Array<Location>) => {
  const locationOptions = locationItems.map((item) => ({
    key: item.id,
    value: item.id,
    label: item.name,
  }));

  return locationOptions;
};

const locationSearchHandler: FilterFunc<DefaultOptionType> = (input, option) => {
  const search = input.toLowerCase();
  const value = option?.label?.toString().toLowerCase?.() ?? "";

  return value.includes(search);
};

type LocationSelectFormItemProps = {
  intl: IntlShape;
  locationItems: Location[];
  rules?: Rule[];
  placeholder?: string | boolean;
  selectProps?: SelectProps<string>;
  form: FormInstance;
};

export const LocationSelectorFormItem = (props: LocationSelectFormItemProps) => {
  const { intl, locationItems, placeholder = false, selectProps, form } = props;

  const options = useMemo(() => locationSelectOptions(locationItems), [locationItems]);

  useEffect(() => {
    if (
      options.filter((item) => {
        return item.key === form.getFieldValue("location");
      }).length <= 0
    ) {
      form.setFieldValue("location", undefined);
    }
  }, [options, form]);

  return (
    <Form.Item
      name="location"
      label={intl.formatMessage({ id: "turbine_location" })}
      rules={[
        {
          required: true,
          message: intl.formatMessage({ id: "validation_message_turbine_location" }),
        },
      ]}
    >
      <Select
        allowClear={true}
        placeholder={placeholder}
        showSearch={true}
        options={options}
        filterOption={locationSearchHandler}
        {...selectProps}
      />
    </Form.Item>
  );
};
